namespace InvData {

    export class ModelEnvironmentLabelHelper {

        public modelEnvironment: ModelEnvironment;

        constructor(modelEnvironment: ModelEnvironment) {
            this.modelEnvironment = modelEnvironment;
        }

        public getEntityLabel(entityOrEntityId): string {
            if (!entityOrEntityId) {
                return "";
            }

            var entity;
            if (typeof entityOrEntityId == "number") {
                entity = this.modelEnvironment.getEntityById(entityOrEntityId);
                if (!entity) {
                    return "EntityId=" + entityOrEntityId;
                }
            }
            else {
                entity = entityOrEntityId;
            }

            if (entity.label) {
                return entity.label;
            }
            else {
                return "EntityId=" + entity.id;
            }
        }

        public getInvestmentLabel(investmentOrInvestmentId): string {
            if (!investmentOrInvestmentId) {
                return "";
            }

            var investment;
            if (typeof investmentOrInvestmentId == "number") {
                investment = this.modelEnvironment.getInvestmentById(investmentOrInvestmentId);
                if (!investment) {
                    return "InvestmentId=" + investmentOrInvestmentId;
                }
            }
            else {
                investment = investmentOrInvestmentId;
            }

            if (investment.label) {
                return investment.label;
            }
            else {
                var ownerLabel = this.getEntityLabel(investment.ownerId);
                var holdingLabel = this.getEntityLabel(investment.holdingId);

                return ownerLabel + " / " + holdingLabel;
            }
        }

        public getResourceLabel(resourceOrResourceId): string {            
            if (!resourceOrResourceId) {
                return "";
            }

            var resource;
            if (typeof resourceOrResourceId == "number") {
                resource = this.modelEnvironment.getResourceById(resourceOrResourceId);
                if (!resource) {
                    return "ResourceId=" + resourceOrResourceId;
                }
            }
            else {
                resource = resourceOrResourceId;
            }

            if (resource.label) {
                return resource.label;
            }
            else {
                return "ResourceId=" + resource.id;
            }
        }

        public getCurrencyCodeLabel(currencyOrCurrencyId): string {
            if (!currencyOrCurrencyId) {
                return "";
            }

            var currency;
            if (typeof currencyOrCurrencyId == "number") {
                currency = this.modelEnvironment.currencies.tryGetById(currencyOrCurrencyId);
                if (!currency) {
                    return "CurrencyId=" + currencyOrCurrencyId;
                }
            }
            else {
                currency = currencyOrCurrencyId;
            }

            if (currency.code) {
                return currency.code;
            }
            else {
                return "CurrencyId=" + currency.id;
            }
        }

        public getPropertyDefinitionLabel(propDefOrpropDefId): string {
            if (!propDefOrpropDefId) {
                return "";
            }

            var propDef;
            if (typeof propDefOrpropDefId == "number") {
                propDef = this.modelEnvironment.propertyDefinitions.tryGetById(propDefOrpropDefId);
                if (!propDef) {
                    return "PropertyDefinitionId=" + propDefOrpropDefId;
                }
            }
            else {
                propDef = propDefOrpropDefId;
            }

            if (propDef.label) {
                return propDef.label;
            }
            else {
                return "PropertyDefinitionId=" + propDef.id;
            }
        }
    }

}
